export enum VideoNumber {
    One = 1,
    Two = 2,
    Three = 3
}
